import Bout from "../../../bout/Bout.js";
import Game from "../../../Game.js";
import ItemProviders from "../../../items/ItemProviders.js";
import Helper from "../../../utils/helper/Helper.js";
import ItemSlot from "../../itemSlot/ItemSlot.js";
import Skills from "../../skills/Skills.js";

export default class Paperdoll {
	constructor(callback) {
		this.callback = callback;
		this.typeContainer = "paperdoll";
		this.player = Bout.that.player;
	}

	init() {
		this.mc = jQuery("#template-paperdoll").clone();
		this.mc.attr("id", "papdol" + Paperdoll.ENUM++);
		this.mc.css("background-image", "url('assets/ui/paperdoll.png')");
		this.build()

	}
	getClip() {
		return this.mc;
	}

	destroy() {

	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}


	build() {
		this.slots = new Array();
		for (let x = 0; x < Paperdoll.SLOTS.length; x++) {
			let id = Paperdoll.SLOTS[x].id;
			Paperdoll.IDS++;
			let itemSlot = new ItemSlot(id, this.createSlot(id), null, Paperdoll.SLOTS[x].accept, this.itemSlotEventsHandler.bind(this))
			//this.slots.push({ id: "" + id, slot: this.createSlot(id, row, col), item: null });
			this.slots.push(itemSlot);
		}

	}

	itemSlotEventsHandler(e) {
		e.data.from = this;
		this.dispatch(e);
	}


	createSlot(id) {
		let slot = jQuery("#template-slot-inventory").clone();
		slot.attr("id", "slopap" + Paperdoll.ENUM++);
		slot.attr("data-ref", id);
		jQuery(".js-slots", this.mc).append(slot);
		jQuery(".js-filled", slot).css({ width: Game.TILE_WIDTH, height: Game.TILE_HEIGHT, left: (Paperdoll.DIM_SLOT - Game.TILE_WIDTH) / 2, top: (Paperdoll.DIM_SLOT - Game.TILE_HEIGHT) / 2 });
		jQuery(".js-over", slot).css("background-image", "url('" + "./assets/ui/highlight_slot.png" + "')");
		this.placeSlot(slot, id)

		return slot;
	}

	placeSlot(slot, id) {
		let desc = this.getSlotDescriptor(id);
		if (desc) {
			slot.css("top", desc.top);
			slot.css("left", desc.left);
		}
	}

	getSlotDescriptor(id) {
		let a = Paperdoll.SLOTS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				return a[x];
			}
		}
		return null;
	}

	addItem(item, containerPos) {
		let retItem = null;
		let itemSlot;
		if (containerPos === -1) {
			// Lo piazza nella sua slot o nella prima libera
			let a = Paperdoll.SLOTS;
			for (let x = 0; x < a.length; x++) {
				let pos = a[x];
				if (pos.accept.indexOf(item.type) >= 0) {
					itemSlot = this.slots[x];
					break;
				}
			}
		} else {
			let a = Paperdoll.SLOTS;
			for (let x = 0; x < a.length; x++) {
				if (a[x].id === containerPos) {
					itemSlot = this.slots[x];
					break;
				}
			}
		}

		if (itemSlot) {
			if (itemSlot.hasItem()) {
				retItem = itemSlot.getItem();
			}
			itemSlot.setItem(item);

		}

		return retItem;

	}

	removeItem(item) {
		for (let x = 0; x < this.slots.length; x++) {
			let itemSlot = this.slots[x];
			if (itemSlot.id === item.containerPos) {
				itemSlot.removeItem(item);
				break;
			}
		}
	}

	hasItem(item) {
		for (let x = 0; x < this.slots.length; x++) {
			let itemSlot = this.slots[x];
			if (itemSlot.id === item.containerPos) {
				return true;
			}
		}
		return false;
	}



	getItemsSlots() {
		return this.slots;
	}

	getDamage() {
		let dam = this.getDamageValue()
		let damage_min = dam[0];
		let damage_max = dam[1];

		if (damage_max === damage_min) {
			return Helper.toNumber(damage_min);
		}
		return Helper.toNumber(damage_min) + "-" + Helper.toNumber(damage_max);
	}

	getDamageValue() {
		let damage_min = this.player.base_damage;
		let damage_max = this.player.base_damage;
		let bonus_damage = 0;
		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				damage_min += this.slots[x].getItem().attack_min;
				damage_max += this.slots[x].getItem().attack_max;
				bonus_damage += this.slots[x].getItem().bonus_damage;
			}
		}
		let item = this.getCurrentWeapon();
		if (!item) {
			damage_min += Paperdoll.DAMAGE_MIN_NO_WEAPON;
			damage_max += Paperdoll.DAMAGE_MAX_NO_WEAPON;
		} else {
			// Controlla i bonus delle skill in base all'arma
			if (item.isSword()) {
				let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_SWORDSMANSHIP);
				let n = bonus_skill / 100 * 5;
				bonus_damage += n;
			} else if (item.isMace()) {
				let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_MACECOMBAT);
				let n = bonus_skill / 100 * 10;
				bonus_damage += n;
			} else {
				// no bonus in damage per fencing
				//let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_FENCING)
			}
		}


		// Armslore
		let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_ARMSLORE)
		let n = bonus_skill / 100 * 10;
		bonus_damage += n;
		//console.log(bonus_damage)

		damage_min = Math.floor(damage_min + (damage_min * bonus_damage / 10) / 100);
		damage_max = Math.floor(damage_max + (damage_max * bonus_damage / 10) / 100);

		if (Bout.that.player.isHungry()) {
			damage_min = Math.floor(damage_min / 2);
			damage_max = Math.floor(damage_max / 2);
		}
		if (Bout.that.player.isThirsty()) {
			damage_min = Math.floor(damage_min / 2);
			damage_max = Math.floor(damage_max / 2);
		}



		return [damage_min, damage_max];
	}


	getArmour() {
		//console.log(armour)
		let armour = this.getArmourValue();
		return Helper.toNumber(armour);
	}

	getArmourValue() {
		let armour = this.player.base_armour;
		let bonus_defense = 0;
		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				armour += this.slots[x].getItem().defense;
				bonus_defense += this.slots[x].getItem().bonus_defense;
			}
		}
		let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_ARMSLORE)
		let n = bonus_skill / 200 * 10;
		//console.log("---")
		//console.log(bonus_defense);
		bonus_defense += n * this.getNumberOfArmourPieceWorn();

		armour = Math.floor(armour + (armour * bonus_defense / 10) / 100);

		if (Bout.that.player.isHungry()) {
			armour = Math.floor(armour / 2);
		}
		if (Bout.that.player.isThirsty()) {
			armour = Math.floor(armour / 2);
		}

		//console.log(armour, bonus_defense);
		return armour;
	}

	getNumberOfArmourPieceWorn() {
		let n = 0;
		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				let item = this.slots[x].getItem();
				if (item.isArmour()) {
					n += 1;
				}
			}
		}
		return n;
	}

	getSpeed() {
		let speed = Math.floor(this.getSpeedValue());
		return Helper.toNumber(speed);
	}

	getSpeedValue() {
		let speed = this.player.base_speed;
		let bonus_speed = 0;

		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				speed += this.slots[x].getItem().speed;
				bonus_speed += this.slots[x].getItem().bonus_speed;
			}
		}

		let item = this.getCurrentWeapon();
		// Controlla i bonus delle skill in base all'arma
		if (item) {
			if (item.isSword()) {
				let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_SWORDSMANSHIP);
				let n = bonus_skill / 100 * 5;
				bonus_speed += n;
				//console.log(n)
			} else if (item.isMace()) {
				// no bonus speed per mace

			} else {
				let bonus_skill = Bout.that.player.getSkillValue(Skills.SKILL_FENCING)
				let n = bonus_skill / 100 * 10;
				bonus_speed += n;
				//console.log(n)
			}
		}



		speed = speed + (speed * bonus_speed / 10) / 100;

		if (Bout.that.player.isHungry()) {
			speed = speed - 6;
		}
		if (Bout.that.player.isThirsty()) {
			speed = speed - 6;
		}



		//console.log(speed, bonus_speed)
		return speed;
	}

	/*
	getSkillsBonuses() {
		let ret = new Array();
		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				let item = this.slots[x].getItem();
				if (item.bonus_skill > 0) {
					ret.push({ id: item.player_skill, value: item.bonus_skill });
				}
			}
		}
		return ret;
	}
	*/
	getCurrentWeapon() {
		let a = this.slots;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === "pap7") {
				return a[x].getItem();
			}

		}
	}
	getCurrentWeaponSlot() {
		let a = this.slots;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === "pap7") {
				return a[x];
			}

		}
	}
	getSlot(id) {
		let a = this.slots;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				return a[x];
			}

		}
	}

	hasLantern() {
		for (let x = 0; x < this.slots.length; x++) {
			if (this.slots[x].hasItem()) {
				let item = this.slots[x].getItem();
				if (item.group === "lantern") {
					return true;
				}
			}
		}
		return false;
	}


}


Paperdoll.IDS = 0;
Paperdoll.ENUM = 0;
Paperdoll.DIM_SLOT = 36;

Paperdoll.SLOTS = [
	{ id: "pap0", top: 14, left: 110, accept: [ItemProviders.TYPE_ARMOUR_HELMS] },
	{ id: "pap1", top: 46, left: 46, accept: [ItemProviders.TYPE_ARMOUR_ARMS] },
	{ id: "pap2", top: 46, left: 174, accept: [ItemProviders.TYPE_JEWEL_NECKLACES] },
	{ id: "pap3", top: 78, left: 110, accept: [ItemProviders.TYPE_ARMOUR_ARMOURS] },
	{ id: "pap4", top: 110, left: 46, accept: [ItemProviders.TYPE_JEWEL_RINGS] },
	{ id: "pap5", top: 110, left: 174, accept: [ItemProviders.TYPE_JEWEL_RINGS] },
	{ id: "pap6", top: 142, left: 110, accept: [ItemProviders.TYPE_ARMOUR_LEGGINGS] },
	{ id: "pap7", top: 174, left: 46, accept: [ItemProviders.TYPE_WEAPON_AXES, ItemProviders.TYPE_WEAPON_HAMMERS, ItemProviders.TYPE_WEAPON_MACES, ItemProviders.TYPE_WEAPON_SPEARS, ItemProviders.TYPE_WEAPON_SWORDS] },
	{ id: "pap8", top: 174, left: 174, accept: [ItemProviders.TYPE_ARMOUR_SHIELDS] },
	{ id: "pap9", top: 206, left: 110, accept: [ItemProviders.TYPE_ARMOUR_SHOES] },
	{ id: "pap10", top: 270, left: 14, accept: [ItemProviders.TYPE_CONSUMABLES_FOOD, ItemProviders.TYPE_CONSUMABLES_POTIONS, ItemProviders.TYPE_TOOLS] },
	{ id: "pap11", top: 270, left: 78, accept: [ItemProviders.TYPE_CONSUMABLES_FOOD, ItemProviders.TYPE_CONSUMABLES_POTIONS, ItemProviders.TYPE_TOOLS] },
	{ id: "pap12", top: 270, left: 142, accept: [ItemProviders.TYPE_CONSUMABLES_FOOD, ItemProviders.TYPE_CONSUMABLES_POTIONS, ItemProviders.TYPE_TOOLS] },
	{ id: "pap13", top: 270, left: 206, accept: [ItemProviders.TYPE_CONSUMABLES_FOOD, ItemProviders.TYPE_CONSUMABLES_POTIONS, ItemProviders.TYPE_TOOLS] }
]

Paperdoll.DAMAGE_MIN_NO_WEAPON = 0;
Paperdoll.DAMAGE_MAX_NO_WEAPON = 4;
